/**
 * えらんでKuradashi 追従フッターの停止位置ロジック（純粋関数）。
 *
 * サイトフッターに重ならないよう、フッターがビューポート下端に入ってきた分だけ
 * 追従バーを上へ押し上げる（バーは表示したまま = 購入導線を維持する）。
 */

/**
 * 追従バーの押し上げ量（px）を求める。
 *
 * @param footerTop     - サイトフッターの上端（ビューポート座標 = getBoundingClientRect().top）
 * @param viewportHeight - ビューポート高さ（window.innerHeight）
 * @returns 押し上げ量（0 以上）。フッターがまだ画面外なら 0。
 *
 * 例: viewport=800, footerTop=750 → フッターが 50px 見えている → 50px 押し上げる。
 */
export function calcStickyFooterOffset(footerTop: number, viewportHeight: number): number {
  const overlap = viewportHeight - footerTop;
  if (!Number.isFinite(overlap) || overlap <= 0) return 0;
  return overlap;
}
